import { useSyncExternalStore } from 'react';
import type { DocsTheme } from './docsBridge';

/** The app's effective theme: `useSyncTheme` puts a `dark` class on `<html>`. */
export function readAppTheme(): DocsTheme {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}

function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
  return () => observer.disconnect();
}

/** Follows the app's light/dark theme as it changes. */
export function useAppTheme(): DocsTheme {
  return useSyncExternalStore(subscribe, readAppTheme, () => 'light');
}
